import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api, unwrap } from "@/lib/api";
import { qk } from "@/lib/query-client";
import type { ApiEnvelope, User } from "@/lib/api-types";
import { useAuth } from "@/hooks/useAuth";

export function useCurrentUser() {
  const { status } = useAuth();
  return useQuery({
    queryKey: qk.me,
    enabled: status === "authenticated",
    queryFn: async () => {
      const res = await api.get<ApiEnvelope<User>>("/users/me");
      return unwrap(res.data);
    },
    staleTime: 60_000,
  });
}

export function useUpdateMe() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (patch: Partial<User>) => {
      const res = await api.put<ApiEnvelope<User>>("/users/me", patch);
      return unwrap(res.data);
    },
    onSuccess: (user) => {
      qc.setQueryData(qk.me, user);
    },
  });
}
